import React, {useState} from "react";
import Header from "../Header";
import {
    TextField,
    Typography,
    Alert,
    IconButton,
    Collapse,
    Checkbox,
    Box
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {useNavigate} from "react-router";
import { useTranslation, withTranslation } from 'react-i18next';

import './CreateMessage.css';
import {useCabanaContext} from "../CabanaContext";
import {Loader} from "../Loader";
import * as EmailValidator from "email-validator";


function CreateMessage() {
    const { user, cart, userType, wishlist, isLoadingWishlist, listCode } = useCabanaContext();
    const {t} = useTranslation();
    const navigate = useNavigate();

    if(userType !== 'gifter'){
        navigate(`/${userType}/404`);
    }
    if(listCode === null){
        navigate(`/${userType}/404`);
    }

    const [gifterName, setGifterName] = useState<string>("");
    const [gifterSurname, setGifterSurname] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const [onWriting, setOnWriting] = useState<boolean>(false);

    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<"error" | "success">("error");
    const [alertText, setAlertText] = useState<any>(t('emptyMessage'));

    const [email, setEmail] = useState<any>('');
    const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
    const [privacyAccepted, setPrivacyAccepted] = useState<boolean>(false);
    const [termsStyle, setTermsStyle] = useState<any>({fontWeight: "400"});
    const [privacyStyle, setPrivacyStyle] = useState<any>({fontWeight: "400"});

    const handleTermsAccepted = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.checked){
            setTermsStyle({fontWeight: "700"});
            setTermsAccepted(true);
        } else {
            setTermsStyle({fontWeight: "400"});
            setTermsAccepted(false);
        }
    }

    const handlePrivacyAccepted = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.checked){
            setPrivacyStyle({fontWeight: "700"});
            setPrivacyAccepted(true)
        } else {
            setPrivacyStyle({fontWeight: "400"});
            setPrivacyAccepted(false)
        }
    }

    const handleGifterName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGifterName(event.target.value);
    }

    const handleGifterSurname = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGifterSurname(event.target.value);
    }

    const handleMessage = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(event.target.value);
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if(email === "") {
            setAlertText(t('emailEmpty'));
            setAlertType("error");
            setAlertOpen(true);
            return;
        }else if(!EmailValidator.validate(email)){
            setAlertText(t('emailNotValid'));
            setAlertType("error");
            setAlertOpen(true);
            return;
        }

        if (gifterName === "") {
            setAlertText(t('gifterNameEmpty'));
            setAlertType("error");
            setAlertOpen(true);
            return;
        }

        if (gifterName.length < 2) {
            setAlertText(t('gifterNameLength'));
            setAlertType("error");
            setAlertOpen(true);
            return;
        }

        if (gifterSurname === "") {
            setAlertText(t('gifterSurnameEmpty'));
            setAlertType("error");
            setAlertOpen(true);
            return;
        }

        if (gifterSurname.length < 2) {
            setAlertText(t('gifterSurnameLength'));
            setAlertType("error");
            setAlertOpen(true);
            return;
        }

        if(message === "") {
            setAlertText(t('emptyMessage'));
            setAlertType("error");
            setAlertOpen(true);
            return;
        }

        if (!termsAccepted) {
            setAlertOpen(true);
            setAlertType("error");
            setAlertText(t("termsNotAcceptedParagraph"));
            return;
        }

        if (!privacyAccepted) {
            setAlertOpen(true);
            setAlertType("error");
            setAlertText(t("privacyNotAcceptedParagraph"));
            return;
        }

        const gifterObject = {
            name: gifterName,
            surname: gifterSurname,
            email: email,
            message: message,
            wishlistId: wishlist.id,
            wishlistCode: listCode,
            products: cart
        }

        localStorage.setItem('gifterObject', JSON.stringify(gifterObject))
        navigate(`/gifter/checkout`);
    }

    const link = `/${userType}/registry/${listCode}`;

    if(user === null || isLoadingWishlist || wishlist === null){
        return <div style={{height: "100vh", width: "100%"}}><Loader/></div>;
    }

    return (
        <div>
            <Header link={link} hideLogout={true} showWishlistLink={true} wishlistUrl={`/gifter/registry/${listCode}`}/>
            <div className="MessageHeader d-flex d-lg-none">
            </div>
            <div className="row no-gutter">
                <div className="col-12 col-lg-3 d-lg-block d-none p-4">
                    <div className="FormTitle"><h4>{t('sendMessage')}</h4></div>
                    <div className="MessageHeader" style={{margin: '0'}}>

                        {cart.length === 0 ? (
                            <Typography className={'cart-empty-text'} variant="body1">Your cart is currently empty.</Typography>
                        ) : (
                            <Box className={'container-cart-products-create-message'}>
                                {cart.map(product => {
                                    return(
                                        <Box key={product.id} className="cart-item-create-message">
                                            <Box className={'img-product-container-create-message'}>
                                                <img
                                                    src={product.image_url}
                                                    alt={'product-cart-image'}
                                                />
                                            </Box>
                                            <Box className={'cart-item-create-message-container-info'}>
                                                <Box>
                                                    <Typography className={'title'}>{product.title.toUpperCase()}</Typography>
                                                    <Typography className={'subtitle'}>{product.subtitle.toUpperCase()}</Typography>
                                                </Box>
                                                <Typography className={'quantity-value'}>Qty: {product.gift_quantity}</Typography>
                                            </Box>
                                        </Box>
                                    )
                                })}
                            </Box>
                        )}


                        <div className="MessageProductTitle">
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <Collapse className="FgiftCustomCollapse" in={alertOpen}>
                        <Alert
                            severity={alertType}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {alertText}
                        </Alert>
                    </Collapse>
                    <form className="CreateMessageForm" onSubmit={handleSubmit}>
                        <div className="FormTitle d-block d-lg-none"><h4>{t('sendMessage')}</h4></div>
                        <div className="EmailContainer">
                            <TextField
                                label={t('emailLabel')}
                                value={email}
                                variant="standard"
                                onChange={(event) => setEmail(event.target.value)}
                                required={true}
                            />
                        </div>
                        <div className="GifterNameContainer">
                            <TextField
                                label={t('gifterNameLabel')}
                                value={gifterName}
                                onChange={handleGifterName}
                                variant="standard"
                                style={{width: '100%'}}
                            />
                        </div>
                        <div className="GifterSurnameContainer">
                            <TextField
                                label={t('gifterSurnameLabel')}
                                value={gifterSurname}
                                onChange={handleGifterSurname}
                                variant="standard"
                                style={{width: '100%'}}
                            />
                        </div>
                        <div className="GifterMessageContainer">
                            <TextField
                                label={t('commentLabel')}
                                multiline
                                variant="standard"
                                placeholder={t('messagePlaceholder')}
                                style={{width: '100%'}}
                                value={message}
                                onChange={handleMessage}
                                onFocus={() => setOnWriting(true)}
                                onBlur={() => setOnWriting(false)}
                                helperText={onWriting ? t('messageLength') : ''}
                                inputProps={{maxLength: 256}}
                            />
                        </div>
                        <Box>
                            <div className="AcceptTermsContainer">
                                <Checkbox
                                    onChange={handleTermsAccepted}
                                    color="primary"
                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                    sx={{
                                        color: 'black',
                                        '&.Mui-checked': {
                                            color: 'black',
                                        },
                                    }}
                                /> <span style={termsStyle}>{t('acceptTermsAndConditionsText')} <a
                                href="https://cabanamagazine.com/pages/terms-and-conditions" target="_blank">{t('termsAndConditions')}</a></span>
                            </div>
                            <div className="AcceptPrivacyContainer mb-5">
                                <Checkbox
                                    onChange={handlePrivacyAccepted}
                                    color="primary"
                                    inputProps={{'aria-label': 'secondary checkbox'}}
                                    sx={{
                                        color: 'black',
                                        '&.Mui-checked': {
                                            color: 'black',
                                        },
                                    }}
                                /> <span style={privacyStyle}>{t('acceptPrivacyPolicyText')} <a
                                href="https://cabanamagazine.com/pages/privacy-policy" target="_blank">{t('privacyPolicy')}</a></span>
                            </div>
                        </Box>
                        <div className="ButtonContainer" style={{width: 'calc(100% - 40px)'}}>
                            <button type="submit" className="Fgift-button" style={{width: '100%'}}>
                                {t('create_message')}
                            </button>
                        </div>
                    </form>
                </div>
                <div className="col-12 col-lg-3 d-md-block d-none">
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(CreateMessage);